import './articles.less'

import {m} from '@codeurs/front'
import {FilterParameterMultiple, FilterParameterSingle} from 'util/filter'
import {Filters, Toggle} from 'views/filter'
import Layout from 'views/layout'
import {Aside} from 'views/layout/aside'
import ContentContainer from 'views/layout/contentcontainer'
import Title from 'views/layout/title'
import {PagedLoader, pagedFilters} from 'views/loader/pagedloader'
import ArticleLink, {ArticleType} from 'views/partials/features/articlelink'
import {ArticleLabel} from 'types'

const ArticlesAside = ({sectors, sector}) => [
	m(Title, {heading: 4}, 'Filter by Sector(s)'),
	m('.publications-sectors',
		m(Filters,
			{filter: sector, style: 'aside'},
			Object.entries(sectors).map(([id, sector]) => m(Toggle, {id}, sector))
		)
	)
]

export class Articles extends Layout {
	state = pagedFilters(({single, multiple}) => ({
		theme: multiple('theme'),
		sector: single('sector'),
		label: single('label')
	}))
	view() {
		const {
			lists: {sectors, policies, tags, authors}
		} = this.attrs.data
		const {theme, sector, label} = this.state
		return m('.articles',
			m(ContentContainer,
				{mod: 'tight'},
				m('.articles-themes',
					m(Title, {heading: 4}, 'Filter by Theme(s)'),
					m(Filters,
						{filter: theme, style: 'theme'},
						Object.entries(policies).map(([id, policy]) =>
							m(Toggle, {id}, policy.name)
						)
					)
				),
				m(Aside, {aside: () => m(ArticlesAside, {sector, sectors})}, [
					m('.articles-categories',
						m(Filters,
							{filter: label, style: 'category'},
							Object.entries(ArticleLabel).map(([id, label]) =>
								m(Toggle, {id}, label)
							)
						)
					),
					m(PagedLoader,
						{
							url: '/api/cms/articles',
							filters: this.state
						},
						({data}) =>
							data.map(article =>
								m('.articles-link', m(ArticleLink, {...article, mod: 'flat'}))
							)
					)
				])
			)
		)
	}
}
